/**
 * frontend/src/components/layout/SearchTrigger.tsx
 * PHASE 3.2 F2 — Bouton Cmd+K + SearchModal.
 *
 * Remplace le placeholder PHASE 3.0 (console.info) par la vraie modal.
 * Le raccourci clavier Cmd+K / Ctrl+K est enregistré ici via useEffect.
 *
 * DECISIONS #167 (placeholder) → PHASE 3.2 F2 (implémentation réelle).
 */

import { useT } from '@/lib/i18n';
import { useState, useEffect } from 'react'
import { Search } from 'lucide-react'
import { SearchModal } from './SearchModal'

export function SearchTrigger() {
  const t = useT();
  const [open, setOpen] = useState(false)

  // ── Raccourci Cmd+K / Ctrl+K ─────────────────────────────────────────────────
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      const isMac    = navigator.platform.toUpperCase().includes('MAC')
      const modifier = isMac ? e.metaKey : e.ctrlKey
      if (modifier && e.key === 'k') {
        e.preventDefault()
        setOpen((prev) => !prev)
      }
    }
    document.addEventListener('keydown', handleKey)
    return () => document.removeEventListener('keydown', handleKey)
  }, [])

  return (
    <>
      <button
        type="button"
        data-testid="search-trigger"
        onClick={() => setOpen(true)}
        aria-label={t('commun.rechercheGlobale')}
        className="flex items-center gap-1.5 rounded-md border border-[var(--border-default)] px-2.5 py-1.5 text-xs text-muted-foreground hover:text-foreground hover:bg-[var(--surface-hover)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-samsung-500/50"
      >
        <Search size={13} className="shrink-0" aria-hidden="true" />
        <span className="hidden sm:inline">{t('commun.rechercher')}</span>
        <kbd className="hidden sm:inline ml-1 rounded bg-[var(--surface-hover)] px-1 py-px text-[10px] font-mono">⌘K</kbd>
      </button>

      <SearchModal open={open} onOpenChange={setOpen} />
    </>
  )
}
